import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { ResultRequestModel } from "../models/resultRequest.model";
import { HttpService } from "./http.service";

const basePath = "/ExternalBranchPickup";
const request = HttpService.handleRequest();

export const ExternalBranchPickupService = {
  GetListByPeriod
};

async function GetListByPeriod(startDate: string, totalDays: number): Promise<ResultRequestModel> {
  return request.get(`${basePath}/GetListByPeriod/${startDate}/${totalDays}`);
}

export default ExternalBranchPickupService;